Hideaways.locationGrids = [];

Hideaways.locationGrid = function() {
    var loop = new Loop();

    loop.array(document.querySelectorAll('.js-location-grid'), function(array, i) {
        var locationGrid = new LocationGrid(array[i]);
        locationGrid.init();

        Hideaways.locationGrids.push(locationGrid);
    });
}
